var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('v-img',{attrs:{"src":require("../../assets/images/icon_null.png"),"max-height":"40px","max-width":"40px"}})],1),_c('div',{staticClass:"text"},[_vm._v("表示するデータがありません")])])
}
var staticRenderFns = []

export { render, staticRenderFns }